import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import About from './pages/About';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import ResumeBuilderLanding from './pages/tools/ResumeBuilderLanding';
import QrCodeGeneratorLanding from './pages/tools/QrCodeGeneratorLanding';
import SizeConverterLanding from './pages/tools/SizeConverterLanding';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-white font-sans antialiased">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/tools/resume-builder" element={<ResumeBuilderLanding />} />
            <Route path="/tools/qr-code-generator" element={<QrCodeGeneratorLanding />} />
            <Route path="/tools/clothing-shoe-size-converter" element={<SizeConverterLanding />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/support" element={<Support />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
